<div class="card-grid-container">
	@if (clientsAreEmpty()) {
		<p>{{ 'client.client_view.no_clients' | transloco }}</p>
	} @else {
		<section class="card-grid">
			@for (client of clients(); track client.id) {
				<!-- Using the client-card component to display each client -->
				<lvr-client-card [client]="client"></lvr-client-card>
			}
		</section>
	}
</div>

@if (page()) {
	<lvr-paginator
		[length]="totalItems()"
		[pageSize]="pageSize()"
		[pageIndex]="pageIndex()"
		[showFirstLastButtons]="showFirstLastButtons"
		[hidePageSize]="hidePageSize"
		preferenceKey="client-list"
		(page)="handlePageEvent($event)"
	>
	</lvr-paginator>
}
